export default __webpack_public_path__ + "static/1410-2b76f9bfa91f02d814ba64e808b43d07.gif";